import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Stepper, } from '@awaze/design-system.components.stepper';
import { Text } from '@awaze/design-system.components.text';
import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { Plus, Remove } from './icon';
import { ButtonStyled, DescriptionStyled, IconStyled, ImageStyled, LabelContainer, StepperContainer, StepperInnerContainer, } from './item-stepper.styles';
/**
 * TODO: Description to be provided by component owner.
 */
export const ItemStepper = ({ id, title, subTitle, description, price, maximumQuantity, onChange, initialValue = 0, stepperRounded = false, stepperColourScheme = 'brand-tertiary', step = 1, minimum = 0, stepperTranslations, addButtonProps = {
    text: 'Add',
    variant: 'outline',
    colourScheme: 'brand-primary',
}, removeButtonProps = {
    text: 'Remove',
    variant: 'outline',
    color: 'ColorStatusAttention500',
}, icon, imageURL, }) => {
    const inputName = id.toString();
    const formHooks = useForm();
    const [quantity, setQuantity] = useState(initialValue);
    const watchFormFields = formHooks.watch(inputName, quantity);
    useEffect(() => {
        onChange({ id, quantity });
    }, [quantity]);
    useEffect(() => {
        if (watchFormFields !== undefined)
            setQuantity(watchFormFields);
    }, [watchFormFields]);
    const ifQuantityNotSelected = quantity === 0;
    const isSingleQuantityItem = maximumQuantity === 1;
    return (_jsxs(StepperContainer, { children: [icon && _jsx(IconStyled, { children: icon }), imageURL && _jsx(ImageStyled, { src: imageURL }), _jsxs(LabelContainer, { children: [title, price] }), _jsx(Text, { sizes: 100, color: "ColorGrey600", children: subTitle }), _jsx(DescriptionStyled, { children: description }), ifQuantityNotSelected ? (_jsx(ButtonStyled, { isFullWidth: true, onClick: () => {
                    setQuantity(step);
                    formHooks.setValue(inputName, step);
                }, icon: _jsx(Plus, {}), ...addButtonProps, "data-testid": inputName })) : isSingleQuantityItem ? (_jsx(ButtonStyled, { isFullWidth: true, onClick: () => {
                    setQuantity(0);
                    formHooks.setValue(inputName, 0);
                }, icon: _jsx(Remove, {}), ...removeButtonProps, "data-testid": inputName })) : (_jsx(StepperInnerContainer, { children: _jsx(Stepper, { translations: stepperTranslations ?? {
                        ariaLabelName: 'stepper',
                        decreaseAriaLabel: 'Decrement',
                        increaseAriaLabel: 'Increment',
                    }, colourScheme: stepperColourScheme, initialValue: quantity, maximum: maximumQuantity, minimum: minimum, rounded: stepperRounded, step: step, name: inputName, formHooks: formHooks }) }))] }));
};
//# sourceMappingURL=item-stepper.js.map